class ClickOutsideDirective {
    constructor($document) {
        this.restrict = 'A';
        this.$document = $document;
    }

    link(scope, element, attrs, controllers) {
        const documentClickOutside = (e) => {
            if (element !== e.target && !element[0].contains(e.target)) {

                if (scope.clickOutside || typeof scope.clickOutside == 'function') {
                    scope.clickOutside();
                    return;
                }

                if (scope.$parent.clickOutside || typeof scope.$parent.clickOutside == 'function') {
                    scope.$parent.clickOutside();
                    return;
                }
            }
        };

        this.$document.on('click', documentClickOutside);

        scope.$on('$destroy', () => {
            this.$document.off('click', documentClickOutside);
        });
    }

    static directiveFactory($document) {
        'ngInject';
        return new ClickOutsideDirective($document);
    }
}

export default ClickOutsideDirective;